import authService from "services/auth.service";
import { create } from "zustand";
import { AUTH_TOKEN, ROLE, USER, USER_LOGGED } from "../constants/AuthConstant";

export const useAuth = create(set => ({
  loading: false,
  message: "",
  showMessage: false,
  redirect: "",
  token: localStorage.getItem(AUTH_TOKEN),
  uuidUser: localStorage.getItem(USER),
  role: localStorage.getItem(ROLE),
  name: localStorage.getItem(USER_LOGGED),

  showAuthMessage: message => {
    set({ message, showMessage: true, loading: false });
  },
  showLoading: () => {
    set({ loading: true });
  },
  hideAuthMessage: () => {
    set({ message: "", showMessage: false });
  },
  authenticated: token => {
    set({ loading: false, redirect: "/app/home", token: token });
  },
  login: async body => {
    set({ loading: true, showMessage: false });

    try {
      const result = await authService.login(body);
      set({
        token: result.access_token,
        uuidUser: result.uuidUser,
        role: result.role,
        name: result.name,
      });
      console.log(result);
      window.localStorage.setItem(AUTH_TOKEN, result.access_token);
      window.localStorage.setItem(USER_LOGGED, result.name);
      window.localStorage.setItem(USER, result.uuidUser);
      window.localStorage.setItem(ROLE, result.role);
    } catch (e) {
      const message =
        e?.response?.data?.message ||
        e?.message ||
        "Não foi possível autenticar. Tente novamente.";
      set({ message, showMessage: true });
    } finally {
      set({
        loading: false,
      });
    }
  },
  logout: () => {
    set({ token: null });
    window.localStorage.removeItem(AUTH_TOKEN);
    window.location.href = "/auth/login";
  },
}));
